import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { UAE } from "../../mock";

const { featured } = UAE;

export const FeaturedWork = () => (
  <section className="bg-[#eae6db]" data-testid="home-featured">
    <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <div className="grid md:grid-cols-12 gap-8 items-end mb-14" data-reveal>
        <div className="md:col-span-7">
          <p className="font-label text-[11px] text-[#c9a15f] mb-6">{featured.tag}</p>
          <h2 className="font-display font-light text-[38px] md:text-[64px] leading-[0.92] tracking-tight">{featured.title}</h2>
          <p className="font-label text-[11px] text-[#8b8578] mt-5">{featured.location}</p>
        </div>
        <div className="md:col-span-5">
          <p className="text-[#5f5a50] text-[14px] md:text-[15px] leading-relaxed font-light">{featured.blurb}</p>
          <Link to="/work" data-testid="featured-view-work-link" className="inline-flex items-center gap-2 mt-8 font-label text-[11px] text-[#23211c] link-underline">
            View our work <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
          </Link>
        </div>
      </div>

      <div className="overflow-hidden mb-4 md:mb-6" data-reveal>
        <img
          src={featured.hero}
          alt={featured.title}
          loading="lazy"
          className="w-full h-[52vh] md:h-[82vh] object-cover hover:scale-[1.02] transition-transform duration-[1200ms] ease-out"
          style={{ filter: "grayscale(6%)" }}
        />
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-reveal>
        {featured.images.map((src) => (
          <div key={src} className="overflow-hidden">
            <img
              src={src}
              alt="Global Headquarters — Abu Dhabi"
              loading="lazy"
              className="w-full h-[300px] md:h-[520px] object-cover hover:scale-[1.03] transition-transform duration-[1000ms] ease-out"
              style={{ filter: "grayscale(6%)" }}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);
